export default {
  list: { lazy: () => import('./GlobalContacts'), component: 'GlobalContactList' },
}
